import React, { useState, useContext } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {
    clearTransferRecipients,
    clearValidateReplenData,
    getDropdownOptionsRequest,
    resetRepleneShippingMethods,
    setSelectedOutsideAccount,
    setShippingDetails,
    storeDistrictTerritoryPayload,
    storeRequestDeliveryDate,
    validatedReplenData,
} from '../../redux/action/actionCreators';
import ReplenHeader from '../components/replenHeader';
import ReplenListView from '../components/replenListView';
import { ReportUsageContext } from 'src/pages/reportUsage';
import { useDynatracePageName } from 'src/common/hooks/useDynatracePageName';
import { ALLTERRITORIES, pageNames } from 'src/constants/appConstants';
import { AllDistricts } from 'src/pages/reportUsage/replen/components/replenConstant';
import { setReplenishmentSurgeryNumber } from 'src/pages/consignmentBilling/redux/actions';
import { useTranslation } from 'react-i18next';
import {
    clearInsideShippingAddress,
    clearOutsideShippingAddress,
} from 'src/pages/reportUsage/redux/action/actionCreators';
import { getRddDate } from 'src/utils/dateUtils';
import { useEffectWithErrorLogging } from 'src/utils/useEffectWithErrorLogging';

const ReplenViewContainer = ({
    onClose,
    shipAddress,
    setShipAddress,
    replenGridData,
    setReplenGridData,
    isReportPayment = false,
    navigateToSpecifiedScreen,
    showReportPayment,
    showCancelPopUp,
}) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const [attnValue, setAttnValue] = useState('');
    const [careOfValue, setCareOfValue] = useState('');
    const [insideAccountDetails, setInsideAccountDetails] = useState(null);
    const [selectedShipTo, setSelectedShipTo] = useState('');
    const [shippingMethodValue, setShippingMethodValue] = useState('');
    const [usageTransferRecipient, setUsageTransferRecipient] = useState('');
    const [selectedBillToId, setSelectedBillToId] = useState('');
    const [isModalMounted, setIsModalMounted] = useState(false);
    const { footerButtonStatuses, setFooterButtonStatuses } =
        useContext(ReportUsageContext);

    const [disableSelectShipToAddressBtn, setDisableSelectShipToAddressBtn] =
        useState(true);
    const [disableClearSelectedBtn, setDisableClearSelectedBtn] =
        useState(true);
    const [popupNotificationsStack, setPopupNotificationsStack] = useState([]);

    const { usageDetails, isInsideTerritory, reportUsageFormObj } = useSelector(
        (state) => ({
            usageDetails: state.reportUsageRootReducer.usageDetails,
            isInsideTerritory:
                state.surgeryvalidateAccountReducer.validateAccount?.data
                    ?.isInsideTerrAcc,
            reportUsageFormObj: state.reportUsageRootReducer.reportUsageObject,
        })
    );

    const [initRender, setInitRender] = useState(true);
    const [accountErrorPopup, setAccountErrorPopup] = useState(false);
    const [surgeonErrorPopup, setSurgeonErrorPopup] = useState(false);
    const [shipToClick, setShipToClick] = useState(false);
    const [applyClickOutside, setApplyClickOutside] = useState(false);

    let districtsFromIndex = districts;
    let territoriesFromIndex = territories;

    const { accounts, districts, territories } = useSelector((state) => ({
        accounts:
            state.reportUsageRootReducer.dropdownData.accounts &&
            state.reportUsageRootReducer.dropdownData.accounts.accounts,
        districts:
            state.reportUsageRootReducer.dropdownData.districts &&
            state.reportUsageRootReducer.dropdownData.districts.districts,
        territories:
            state.reportUsageRootReducer.dropdownData.territories &&
            state.reportUsageRootReducer.dropdownData.territories.territories
                ? state.reportUsageRootReducer.dropdownData.territories &&
                  state.reportUsageRootReducer.dropdownData.territories
                      .territories
                : territoriesFromIndex,
    }));

    const { surgeryDetails, replenishmentSurgeryNumber } = useSelector(
        (state) => ({
            surgeryDetails:
                state.reportShipToAddressReducer.insideSurgeryDetails,
            replenishmentSurgeryNumber:
                state.reportUsageRootReducer.replenishmentSurgeryNumber,
        })
    );
    const SurgeryDate = useSelector(
        (state) => state.reportUsageRootReducer.surgeryDate
    );
    const RequestDeliveryDate = useSelector(
        (state) => state.reportUsageRootReducer.requestDeliveryDate
    );
    const districtAndTerritory = useSelector(
        (state) => state.reportUsageRootReducer.districtAndTerritory
    );
    const showShipToAddressPopup = useSelector(
        (state) => state.reportUsageRootReducer.showShipToAddressPopup
    );
    const accountError = useSelector(
        (state) => state.reportUsageRootReducer.accountError
    );
    const surgeonError = useSelector(
        (state) => state.reportUsageRootReducer.surgeonError
    );
    const productsWithError = useSelector(
        (state) => state.reportUsageRootReducer.productsWithError
    );

    useDynatracePageName(pageNames.reportUsageReplen);

    useEffectWithErrorLogging(() => {
        setIsModalMounted(shipAddress);
    }, [shipAddress]);

    useEffectWithErrorLogging(() => {
        setIsModalMounted(shipAddress);
    }, [shipAddress]);

    useEffectWithErrorLogging(() => {
        dispatch(getDropdownOptionsRequest('districts'));
    }, []);

    useEffectWithErrorLogging(() => {
        var popups = [];
        if (accountError?.length > 0 || surgeonError?.length > 0) {
            if (accountError.length > 0) {
                popups.push({ accountError: true });
            }
            if (surgeonError.length > 0) {
                popups.push({ surgeonError: true });
            }
            setPopupNotificationsStack(popups);
        } else {
            if (shipToClick) {
                ApplyShipToAddress();
                setShipToClick(false);
            }
        }
    }, [accountError, surgeonError]);

    useEffectWithErrorLogging(() => {
        if (popupNotificationsStack.length != 0) {
            if (popupNotificationsStack[0].accountError) {
                setAccountErrorPopup(true);
            } else if (popupNotificationsStack[0].surgeonError) {
                setSurgeonErrorPopup(true);
            }
        }
    }, [popupNotificationsStack]);

    useEffectWithErrorLogging(() => {
        if (districts && districts[0] && districts[0].districtCode) {
            const payloadObj = {
                districtCode:
                    districts?.length === 1
                        ? districts[0].districtCode !== AllDistricts
                            ? districts[0].districtCode
                            : ''
                        : usageDetails?.districtId &&
                          usageDetails.districtId === AllDistricts
                        ? ''
                        : usageDetails.districtId &&
                          usageDetails.districtId !== undefined
                        ? usageDetails.districtId
                        : districts[0].districtCode !== AllDistricts
                        ? districts[0].districtCode
                        : '',
                searchParam: '',
            };
            dispatch(getDropdownOptionsRequest('territories', payloadObj));
        }
    }, [districts]);

    useEffectWithErrorLogging(() => {
        if (
            districts &&
            districts[0] &&
            districts[0].districtCode &&
            territories
        ) {
            const payloadObj = {
                district: initRender
                    ? districts?.length === 1
                        ? districts[0].districtCode
                        : usageDetails?.districtId
                        ? usageDetails.districtId
                        : ''
                    : districtAndTerritory?.district,
                territory: initRender
                    ? territories.length === 1
                        ? territories[0].terrirotryCode
                        : usageDetails?.territoryId
                        ? usageDetails.territoryId
                        : ''
                    : districtAndTerritory?.territory,
                searchParam:
                    usageDetails.districtId === AllDistricts &&
                    usageDetails?.territoryId === ALLTERRITORIES
                        ? usageDetails?.accountId || ''
                        : '',
                isReplenishmentPage: true,
            };
            if (initRender) {
                dispatch(storeDistrictTerritoryPayload(payloadObj));
                setInitRender(false);
            }
            dispatch(getDropdownOptionsRequest('accounts', payloadObj));
        }
    }, [districts, territories]);

    useEffectWithErrorLogging(() => {
        // enable/disable procedure and save&Exit footer button in Replenish Request Page
        const modifiedButtonStatuses = footerButtonStatuses.map((x) =>
            x.btnName !==
                t('reportUsage.reportUsageFooterbuttons.cancelButton') &&
            x.btnVisibility
                ? {
                      ...x,
                      isBtnDisable: replenGridData?.some(
                          (item) => item.isInvalidReplenQty?.length > 0
                      ),
                  }
                : x
        );
        setFooterButtonStatuses(modifiedButtonStatuses);
        if (
            replenGridData.length > 0 &&
            replenGridData.some(
                (x) => x.isSelected && !x.accountOwned && !x.isExcludedItem
            ) &&
            districts?.length &&
            territories?.length &&
            accounts?.length
        ) {
            setDisableSelectShipToAddressBtn(
                replenGridData.some(
                    (item) => item.isInvalidReplenQty?.length > 0
                )
            );
            if (
                replenGridData.some(
                    (x) =>
                        x.isSelected &&
                        !x.accountOwned &&
                        !x.isExcludedItem &&
                        x.shippingDetails &&
                        Object.keys(x.shippingDetails).length > 0
                )
            ) {
                setDisableClearSelectedBtn(false);
            } else {
                setDisableClearSelectedBtn(true);
            }
        } else {
            setDisableSelectShipToAddressBtn(true);
            setDisableClearSelectedBtn(true);
        }
    }, [replenGridData, districts, territories, accounts, showCancelPopUp]);

    const { surgeryDetailsPhysician } = useSelector((state) => ({
        surgeryDetailsPhysician:
            state.reportShipToAddressReducer.insideSurgeryDetails,
    }));

    const ApplyShipToAddress = () => {
        const territoryPayloadObj = {
            districtCode:
                districtAndTerritory?.district &&
                (districtAndTerritory.district === AllDistricts
                    ? ''
                    : districtAndTerritory.district),
            searchParam: '',
            isReplenishmentPage: true,
        };
        dispatch(getDropdownOptionsRequest('territories', territoryPayloadObj));
        const payloadObj = {
            district: districtAndTerritory?.district,
            territory: districtAndTerritory?.territory,
            searchParam: '',
            isReplenishmentPage: true,
        };
        dispatch(getDropdownOptionsRequest('accounts', payloadObj));
        dispatch(clearTransferRecipients());

        let modifiedGridData = replenGridData?.map((item) => {
            const updatedItem = { ...item };
            const isUpdate =
                item?.isSelected &&
                !item?.accountOwned &&
                !productsWithError?.includes(item?.cfn);
            if (isUpdate) {
                updatedItem.shippingDetails = {
                    shippingAddress: selectedShipTo || '',
                    shippingMethod: shippingMethodValue || '',
                    // accountDetails: surgeryDetails.accountId,
                    accountDetails: insideAccountDetails || null,
                    attnLine: attnValue || '',
                    requestDeliveryDate:
                        RequestDeliveryDate !== ''
                            ? getRddDate(RequestDeliveryDate)
                            : '',
                    surgeryDate:
                        SurgeryDate !== '' ? getRddDate(SurgeryDate) : '',
                    surgeryNumber:
                        replenishmentSurgeryNumber !== ''
                            ? replenishmentSurgeryNumber
                            : '',
                    ...(careOfValue && { careOfField: careOfValue }),
                    transferRecipient: usageTransferRecipient || '',
                    value: usageTransferRecipient || '',
                    ...(selectedBillToId?.billToNumber && { billToId: selectedBillToId.billToNumber }),
                    physicianId: surgeryDetails?.physicianId || '',
                    isOutSide: applyClickOutside,
                };
            }
            updatedItem.isSelected = false;
            return updatedItem;
        }) || [];

        modifiedGridData = modifiedGridData.map((i) => {
            return {
                ...i,
                replenishmentDetails: {
                    physician: surgeryDetailsPhysician?.physicianId || '',
                },
            };
        });
        // dispatch(setShippingDetails(
        //     cpy.gridData
        // ))

        setReplenGridData(modifiedGridData);
        dispatch(setShippingDetails(modifiedGridData));
        setAttnValue('');
        setCareOfValue('');
        dispatch(setReplenishmentSurgeryNumber(''));
        dispatch(resetRepleneShippingMethods());
        dispatch(clearValidateReplenData());
        dispatch(clearTransferRecipients());
        dispatch(clearOutsideShippingAddress());
        dispatch(clearInsideShippingAddress());        
        // dispatch(clearInsideShippingAddress());
    };

    const headerCheckboxClickHandler = (e) => {
        const modifiedGridData = replenGridData.map((x) => ({
            ...x,
            isSelected: !x.isExcludedItem && e.target.checked,
        }));
        setReplenGridData(modifiedGridData);
    };

    const checkboxClickHandler = (e, item) => {
        const modifiedGridData = [...replenGridData];
        const selectedIdx = modifiedGridData.findIndex(
            (x) => x.cfn === (e.target.name || item.cfn)
        );
        if (selectedIdx >= 0) {
            modifiedGridData[selectedIdx].isSelected = e.target.checked;
            setReplenGridData(modifiedGridData);
        }
    };

    const clearSelectedClickHandler = () => {
        const selectedItemIds = replenGridData
            .filter((x) => x.isSelected && !x.accountOwned)
            .map((y) => y.cfn);
        const modifiedGridData = replenGridData.map((obj) => ({
            ...obj,
            shippingDetails: selectedItemIds.includes(obj.cfn)
                ? null
                : obj.shippingDetails,
            isSelected: false,
        }));
        setReplenGridData(modifiedGridData);
        dispatch(storeRequestDeliveryDate(''));
        dispatch(setShippingDetails(modifiedGridData));
    };

    const applyShippingAddress = () => {
        dispatch(
            validatedReplenData(
                replenGridData.filter((data) => data.isSelected)
            )
        );
    };

    const selectShipToAddressClickHandler = () => {
        dispatch(clearOutsideShippingAddress());
        dispatch(clearInsideShippingAddress());
        dispatch(storeRequestDeliveryDate(''));
        dispatch(setReplenishmentSurgeryNumber(''));
        dispatch(resetRepleneShippingMethods());
        dispatch(clearTransferRecipients());
        setSelectedShipTo('');
        setShippingMethodValue('');
        setSelectedBillToId('');
        setUsageTransferRecipient('');
        setInsideAccountDetails(null);
        setAttnValue('');
        setCareOfValue('');
        setApplyClickOutside(false);
        setShipToClick(false);
        // dispatch(
        //     validatedReplenData(
        //         replenGridData.filter((data) => data.isSelected)
        //     )
        // );
        if (isInsideTerritory === false && reportUsageFormObj?.accountId) {
            dispatch(
                setSelectedOutsideAccount({
                    accountId: reportUsageFormObj?.accountId || '',
                    accountName: reportUsageFormObj?.accountName || '',
                    accountFormattedName:
                        reportUsageFormObj?.accountFormattedName || '',
                })
            );
        }
        // setShipToClick(true);
        // if (accountError?.length === 0 || surgeonError?.length === 0)
        setIsModalMounted(true);
        setShipAddress(true);
    };

    return (
        <>
            <ReplenHeader
                disableSelectShipToAddressBtn={disableSelectShipToAddressBtn}
                disableClearSelectedBtn={disableClearSelectedBtn}
                clearSelectedClickHandler={clearSelectedClickHandler}
                onClose={onClose}
                shipAddress={shipAddress}
                setShipAddress={setShipAddress}
                gridData={replenGridData}
                setGridData={setReplenGridData}
                districtsFromIndex={districtsFromIndex}
                territoriesFromIndex={territoriesFromIndex}
                isReportPayment={isReportPayment}
                navigateToSpecifiedScreen={navigateToSpecifiedScreen}
                selectShipToAddressClickHandler={
                    selectShipToAddressClickHandler
                }
                surgeonErrorPopup={surgeonErrorPopup}
                accountErrorPopup={accountErrorPopup}
                accountError={accountError}
                surgeonError={surgeonError}
                popupNotificationsStack={popupNotificationsStack}
                setPopupNotificationsStack={setPopupNotificationsStack}
                setAccountErrorPopup={setAccountErrorPopup}
                setSurgeonErrorPopup={setSurgeonErrorPopup}
                showShipToAddressPopup={showShipToAddressPopup}
                applyShippingAddress={applyShippingAddress}
                ApplyShipToAddress={ApplyShipToAddress}
                setSelectedBillToId={setSelectedBillToId}
                selectedBillToId={selectedBillToId}
                setUsageTransferRecipient={setUsageTransferRecipient}
                usageTransferRecipient={usageTransferRecipient}
                setShippingMethodValue={setShippingMethodValue}
                shippingMethodValue={shippingMethodValue}
                setSelectedShipTo={setSelectedShipTo}
                selectedShipTo={selectedShipTo}
                setShipToClick={setShipToClick}
                applyClickOutside={applyClickOutside}
                setApplyClickOutside={setApplyClickOutside}
                shipToClick={shipToClick}
                setCareOfValue={setCareOfValue}
                careOfValue={careOfValue}
                setInsideAccountDetails={setInsideAccountDetails}
                insideAccountDetails={insideAccountDetails}
                setAttnValue={setAttnValue}
                attnValue={attnValue}
                showReportPayment={showReportPayment}
            />
            <ReplenListView
                gridData={replenGridData}
                setGridData={setReplenGridData}
                headerCheckboxClickHandler={headerCheckboxClickHandler}
                checkboxClickHandler={checkboxClickHandler}
            />
        </>
    );
};

export default ReplenViewContainer;
